import React from 'react';
import { useForm } from 'react-final-form';

import { useFieldValue } from 'Shared/utils/hooks';
import AddMoreButton from '../../AddMoreButton/AddMoreButton';
import { generateEmptyWorkspace } from '../../Workspaces/utils';

type Props = {
  label: string;
};

export default function WorkspaceAddMoreButton({ label }: Props) {
  const { mutators: formMutators } = useForm();
  const workspaces = useFieldValue('workspaces');

  const handleClick = () => {
    const indexOfLastManualWorkspace = workspaces
      .map(({ recurring_meeting_uuid }) => !!recurring_meeting_uuid)
      .lastIndexOf(false);

    formMutators.insert('workspaces', indexOfLastManualWorkspace + 1, generateEmptyWorkspace());
  };

  return <AddMoreButton className="mt-2" label={label} action={handleClick} />;
}
